import { Fragment } from 'react';

import styles from './BottomSheet.module.scss';
import { CachedImage } from '../CachedImage';

export interface BottomSheetProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  image?: string;
  title?: string;
  subtitle?: string;
  buttons?: React.ReactNode[];
  buttonDirection?: 'row' | 'column';
}

export const BottomSheet = ({
  image,
  title,
  subtitle,
  buttons,
  buttonDirection = 'column',
  children,
  ...props
}: BottomSheetProps) => {
  return (
    <div
      {...props}
      className={styles.bottomSheet}
      data-test-id="bottom-sheet-container"
    >
      {image && (
        <CachedImage
          testId="cached-image"
          className={styles.image}
          src={image}
          alt="bottom-image"
        />
      )}

      {title && (
        <div className={styles.header} data-test-id="bottom-sheet-header">
          <div className={styles.title} data-test-id="bottom-sheet-title">
            {title}
          </div>
          {subtitle && (
            <div
              className={styles.subtitle}
              data-test-id="bottom-sheet-subtitle"
              dangerouslySetInnerHTML={{ __html: subtitle }}
            />
          )}
        </div>
      )}

      {children && (
        <div className={styles.children} data-test-id="bottom-sheet-children">
          {children}
        </div>
      )}

      {buttons && (
        <div
          className={styles.buttons}
          data-test-id="bottom-sheet-buttons"
          style={{
            flexDirection: buttonDirection === 'column' ? 'column' : 'row',
          }}
        >
          {buttons.map((b, i) => (
            <Fragment key={i}>{b}</Fragment>
          ))}
        </div>
      )}
    </div>
  );
};
